import { render, staticRenderFns } from "./templateconf-add-or-update.vue?vue&type=template&id=4d6ad0d9&"
import script from "./templateconf-add-or-update.vue?vue&type=script&lang=js&"
export * from "./templateconf-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports